import TableCellDescription from "ds/components/Table/Row/CellDescription";

import EnvironmentTableCell from "../Cell";
import { EnvironmentContextCellProps } from "./types";

const ContextDescriptionCell = ({ item, ...cellProps }: EnvironmentContextCellProps) => {
  return (
    <EnvironmentTableCell {...cellProps}>
      <TableCellDescription description={item.contextDescription} />
    </EnvironmentTableCell>
  );
};

export default ContextDescriptionCell;
